export enum projectType {
    JEANMONNET = 'Jean monnet',
    EMJMD = 'Emjmd'
}